import { render, staticRenderFns } from "./AddHeNan.vue?vue&type=template&id=4bf18a46&scoped=true&"
import script from "./AddHeNan.vue?vue&type=script&lang=js&"
export * from "./AddHeNan.vue?vue&type=script&lang=js&"
import style0 from "./AddHeNan.vue?vue&type=style&index=0&id=4bf18a46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf18a46",
  null
  
)

export default component.exports